import { getScoreCategory, type NpsBrandConfig } from "@repo/nps";
import { NPS_COMPLETED_VALUES } from "@repo/statsig";
import PRODUCT_NAME from "src/lib/product-name";
import thankyouImage from "../assets/thankyou.png";

function followUp(score: number): string {
  switch (getScoreCategory(score)) {
    case NPS_COMPLETED_VALUES.PROMOTER:
      return `What do you love most about ${PRODUCT_NAME}?`;
    case NPS_COMPLETED_VALUES.PASSIVE:
      return `What improvement would make you recommend ${PRODUCT_NAME} to others?`;
    case NPS_COMPLETED_VALUES.DETRACTOR:
    default:
      return "Sorry to hear that. Please tell us why you chose that score.";
  }
}

export const kinsaNpsConfig: NpsBrandConfig = {
  cooldownDays: 90,
  deferralDays: 0, // no deferral path: every close burns the full cooldown
  thankYouIllustration: thankyouImage,
  copy: {
    productName: PRODUCT_NAME,
    question: `How likely are you to recommend ${PRODUCT_NAME}?`,
    description: "This will help us improve your experience.",
    consentLabel: "It's okay to contact me about this feedback.",
    confirmation: "Thanks for the feedback.",
    followUp,
  },
};
